import { observer } from 'mobx-react-lite'
import { DeleteDocumentDialog } from '@/features/documents/DeleteDocumentDialog'
import { type DeleteDocumentDialogViewModel } from './DeleteDocumentDialogViewModel'

export interface DeleteDocumentDialogContainerProps {
  vm: DeleteDocumentDialogViewModel
}

export const DeleteDocumentDialogContainer = observer(
  function DeleteDocumentDialogContainer({
    vm,
  }: DeleteDocumentDialogContainerProps) {
    return (
      <DeleteDocumentDialog
        showing={vm.modal.showing}
        isPending={vm.delete.pending}
        onConfirm={vm.delete}
        onDecline={vm.cancel}
        testId="delete-document"
      />
    )
  },
)
